// src/pages/Works.js
import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import { translations, artworks as artworksMock } from "../data/mock";
import "../styles/portfolio.css";

const Works = () => {
  const { language, t } = useLanguage();
  const [activeFilter, setActiveFilter] = useState("all");
  const [artworks, setArtworks] = useState([]);
  const [loading, setLoading] = useState(true);

  const norm = (s = "") =>
    String(s)
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "")
      .toLowerCase();

  const isFake = (w) => {
    const seriesOk =
      w?.series && (w.series.en === "F.A.K.E." || w.series.it === "F.A.K.E.");

    const cats = Array.isArray(w?.categories)
      ? w.categories
      : [w?.category].filter(Boolean);

    const catOk = cats.map(norm).includes("fake");

    return seriesOk || catOk;
  };

  const isTinder = (w) => {
    const seriesOk =
      w?.series && (w.series.en === "T.I.N.D.E.R." || w.series.it === "T.I.N.D.E.R.");

    const cats = Array.isArray(w?.categories)
      ? w.categories
      : [w?.category].filter(Boolean);

    const catOk = cats.map(norm).includes("tinder");

    return seriesOk || catOk;
  };

  useEffect(() => {
    // carica mock e filtra fuori FAKE e TIN-DER (hanno le loro pagine dedicate)
    const filtered = (artworksMock || []).filter((w) => !isFake(w) && !isTinder(w));
    setArtworks(filtered);
    setLoading(false);
  }, []);

  const visibleArtworks = useMemo(() => {
    const base = artworks;

    if (activeFilter === "all") return base;

    const k = norm(activeFilter);
    return base.filter((w) => {
      const cats = Array.isArray(w.categories)
        ? w.categories
        : [w.category].filter(Boolean);

      return cats.map(norm).includes(k);
    });
  }, [artworks, activeFilter]);

  const filters = [
    { key: "all", label: translations.works.all },
    { key: "sculpture", label: translations.works.sculpture },
    { key: "wearable", label: translations.works.wearable },
    { key: "installation", label: translations.works.installation },
  ];

  return (
    <div style={{ paddingTop: "80px" }}>
      <section className="section-spacing page-offset">
        <div className="container">
          <div style={{ textAlign: "center", marginBottom: "var(--spacing-2xl)" }}>
            <h1 className="section-title">{t(translations.works.title)}</h1>
          </div>

          {/* Filter Bar */}
          <div className="filter-bar">
            {filters.map((filter) => (
              <button
                key={filter.key}
                className={`filter-btn ${activeFilter === filter.key ? "active" : ""}`}
                onClick={() => setActiveFilter(filter.key)}
              >
                {t(filter.label)}
              </button>
            ))}
          </div>

          {loading ? (
            <div style={{ textAlign: "center", padding: "var(--spacing-3xl)" }}>
              <p className="body-text">Loading...</p>
            </div>
          ) : (
            <div className="grid-3">
              {visibleArtworks.map((work, index) => (
                <div
                  key={work.id}
                  className="artwork-card fade-in-up"
                  style={{ animationDelay: `${index * 0.05}s` }}
                >
                  <Link to={`/${language}/works/${work.id}`}>
                    <div className="image-box">
                      <img
                        src={work.image}
                        alt={t(work.title)}
                        className="artwork-image"
                        onError={(e) => {
                          e.currentTarget.src = "/media/placeholder.jpg";
                        }}
                      />
                    </div>

                    <div className="artwork-info">
                      <h3 className="artwork-title">{t(work.title)}</h3>
                      <div className="artwork-meta">
                        <span className="small-text">{work.year}</span>

                        <span className="category-badge">
                          {(() => {
                            const cat =
                              work.category ||
                              (Array.isArray(work.categories) ? work.categories[0] : null);

                            return cat && translations.works[cat]
                              ? t(translations.works[cat])
                              : (cat || "");
                          })()}
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Works;
